.TableGroupHeader {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-lg);
}

.TableGroupHeaderContent {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.TableGroupHeaderIcon {
  border-radius: var(--radius-sm);
  display: flex;
  background-color: var(--bg);
  padding: var(--space-sm);

  & > svg {
    width: 16px;
    height: 16px;

    :global(.arrow) {
      color: black;
    }
  }
}
